namespace GeniuzPOS.ReportMasterData {
    export class Report_1105Columns {
        static columnsKey = 'ReportMasterData.Report_1105';
    }
}
